import { films } from "@/mocks/films";
import { ranking } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

const trendStyle: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "bg-accent-100 text-accent-700" },
  down: { icon: "ri-arrow-down-line", cls: "bg-secondary-100 text-secondary-800" },
  flat: { icon: "ri-subtract-line", cls: "bg-background-200 text-foreground-600" },
  new: { icon: "ri-star-line", cls: "bg-primary-100 text-primary-700" },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="本周排行榜"
          title="伦理片排行榜 · 口碑与热度综合 Top 10"
          desc="榜单综合站内评分、观看量与近期讨论热度排序，并标注了名次变化。分数代表长期口碑，趋势代表当下热度，两者结合更接近真实的选择参考。"
        />

        <div className="mt-10 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {ranking.map((item) => {
            const film = films.find((f) => f.id === item.filmId);
            if (!film) return null;
            const trend = trendStyle[item.trend];
            return (
              <article
                key={item.rank}
                className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-300 hover:border-primary-400 md:gap-4 md:p-4"
              >
                <span
                  className={`w-8 shrink-0 text-center font-heading text-2xl md:text-3xl ${
                    item.rank <= 3 ? "text-primary-600" : "text-foreground-300"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img src={film.cover} alt={`${film.title} 海报`} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate font-heading text-base text-foreground-950">{film.title}</h3>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900">
                      {film.genre}
                    </span>
                  </div>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{film.summary}</p>
                  <div className="mt-1.5 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
                    <span>{film.year}</span>
                    <span aria-hidden="true">·</span>
                    <span>{film.region}</span>
                    <span aria-hidden="true">·</span>
                    <span>导演 {film.director}</span>
                  </div>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1.5">
                  <span className="font-heading text-lg text-primary-700">{film.rating.toFixed(1)}</span>
                  <span className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] ${trend.cls}`}>
                    <i className={trend.icon}></i>
                    {item.change}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}